import React from 'react';

/**
 * EndCallIcon - holito brand-tier icon (2px stroke, 24 grid, the notch where applicable).
 * Geometry from the brand guide (docs/DESIGN.md section 08 / Iconography).
 */
export const EndCallIcon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    {...props}
  >
    <g transform="rotate(135 12 12)">
      <path d="M5 4 H9 L11 9 L8 11 C9 13 11 15 13 16 L15 13 L20 15 V19 C20 19 19 20 18 20 C10 20 4 14 4 6 C4 5 4 4 5 4 Z" />
    </g>
  </svg>
);
